import { create } from 'zustand'
import { PRODUCTS } from '../data/products'

type Product = (typeof PRODUCTS)[0]

export interface CartItem {
  product: Product
  quantity: number
}

interface CartStore {
  items: CartItem[]
  isCartOpen: boolean
  isAddedModalOpen: boolean
  lastAddedProduct: Product | null
  addItem: (product: Product) => void
  removeItem: (productId: number) => void
  updateQuantity: (productId: number, quantity: number) => void
  clearCart: () => void
  openCart: () => void
  closeCart: () => void
  closeAddedModal: () => void
}

export const useCartStore = create<CartStore>((set) => ({
  items: [],
  isCartOpen: false,
  isAddedModalOpen: false,
  lastAddedProduct: null,

  addItem: (product) =>
    set((state) => {
      const existingItem = state.items.find(
        (item) => item.product.id === product.id,
      )
      if (existingItem) {
        return {
          items: state.items.map((item) =>
            item.product.id === product.id
              ? { ...item, quantity: item.quantity + 1 }
              : item,
          ),
          isAddedModalOpen: true,
          lastAddedProduct: product,
        }
      }
      return {
        items: [...state.items, { product, quantity: 1 }],
        isAddedModalOpen: true,
        lastAddedProduct: product,
      }
    }),

  removeItem: (productId) =>
    set((state) => ({
      items: state.items.filter((item) => item.product.id !== productId),
    })),

  updateQuantity: (productId, quantity) =>
    set((state) => ({
      items: state.items.map((item) =>
        item.product.id === productId
          ? { ...item, quantity: Math.max(1, quantity) }
          : item,
      ),
    })),

  clearCart: () => set({ items: [] }),

  openCart: () => set({ isCartOpen: true, isAddedModalOpen: false }),
  closeCart: () => set({ isCartOpen: false }),
  closeAddedModal: () => set({ isAddedModalOpen: false }),
}))
